import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  const toggleAccordion = (section: string) => {
    setOpenAccordion(openAccordion === section ? null : section);
  };

  const quickLinks = [
    { name: 'الرئيسية', path: '/' },
    { name: 'الخدمات', path: '/services' },
    { name: 'من نحن', path: '/about' },
    { name: 'تواصل معنا', path: '/contact' }
  ];

  const services = [
    { name: 'الإنشاءات والطرق', path: '/services/construction' },
    { name: 'البترول', path: '/services/oil' },
    { name: 'الذهب', path: '/services/gold' },
    { name: 'التسليح', path: '/services/defense' },
    { name: 'الاستشارات', path: '/services/consulting' }
  ];

  return (
    <footer className="bg-[#2B2C2E] text-white" dir="rtl">
      <div className="container mx-auto px-4 py-16">
        {/* Desktop Layout */}
        <div className="hidden md:grid md:grid-cols-4 gap-12">
          {/* Column 1: Company Identity with Logo */}
          <div className="space-y-6 md:col-span-2">
            <div>
              {/* Logo */}
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 flex items-center justify-center ml-4">
                  <img 
                    src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png" 
                    alt="شركة فيبا التجارية" 
                    className="h-16 w-auto"
                  />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-white mb-1">شركة فيبا التجارية</h2>
                  <p className="text-[#E71B25] text-sm font-medium">VIPA Trading Company</p>
                </div>
              </div>
              
              <p className="text-gray-300 text-base leading-relaxed mb-6">
                شركة كويتية رائدة متعددة الأنشطة، نقدم حلولاً متكاملة في الإنشاءات والطرق، البترول، الذهب، التسليح، والاستشارات بأعلى معايير الجودة العالمية.
              </p>
              
              {/* Contact Info */}
              <div className="space-y-3">
                <a 
                  href="mailto:info@vipatradingco.com" 
                  className="text-gray-300 hover:text-[#E71B25] transition-colors text-base inline-flex items-center cursor-pointer group"
                >
                  <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center ml-3 group-hover:bg-[#E71B25] transition-colors">
                    <i className="ri-mail-line text-sm"></i>
                  </div>
                  info@vipatradingco.com
                </a>
                
                <div className="text-gray-300 text-base inline-flex items-center">
                  <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center ml-3">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  الكويت
                </div>
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-white font-bold text-xl mb-8 relative">
              روابط سريعة
              <div className="absolute bottom-0 right-0 w-12 h-0.5 bg-[#E71B25]"></div>
            </h3>
            <ul className="space-y-4">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-left-s-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Our Services */}
          <div>
            <h3 className="text-white font-bold text-xl mb-8 relative">
              خدماتنا
              <div className="absolute bottom-0 right-0 w-12 h-0.5 bg-[#E71B25]"></div>
            </h3>
            <ul className="space-y-4">
              {services.map((service, index) => (
                <li key={index}>
                  <Link 
                    to={service.path} 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-left-s-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Mobile Accordion Layout */}
        <div className="md:hidden space-y-6">
          {/* Company Identity - Always Visible */}
          <div className="space-y-4 pb-8 border-b border-gray-600">
            {/* Logo */}
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 flex items-center justify-center ml-3">
                <img 
                  src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png" 
                  alt="شركة فيبا التجارية" 
                  className="h-12 w-auto"
                />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white">شركة فيبا التجارية</h2>
                <p className="text-[#E71B25] text-xs">VIPA Trading Company</p>
              </div>
            </div>
            
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              شركة كويتية رائدة متعددة الأنشطة، نقدم حلولاً متكاملة في مختلف المجالات بأعلى معايير الجودة.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <a 
                href="mailto:info@vipatradingco.com" 
                className="text-gray-300 hover:text-[#E71B25] transition-colors text-sm inline-flex items-center cursor-pointer"
              >
                <i className="ri-mail-line ml-2"></i>
                info@vipatradingco.com
              </a>
              <div className="text-gray-300 text-sm inline-flex items-center">
                <i className="ri-map-pin-line ml-2"></i>
                الكويت
              </div>
            </div>
          </div>

          {/* Quick Links Accordion */}
          <div className="border-b border-gray-600 pb-4">
            <button
              onClick={() => toggleAccordion('quick')}
              className="w-full flex items-center justify-between text-white font-semibold text-lg py-3 cursor-pointer whitespace-nowrap"
            >
              روابط سريعة
              <i className={`ri-arrow-down-s-line transition-transform ${openAccordion === 'quick' ? 'rotate-180' : ''}`}></i>
            </button>
            {openAccordion === 'quick' && (
              <ul className="mt-4 space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <Link 
                      to={link.path} 
                      className="text-gray-300 hover:text-[#E71B25] transition-colors text-sm cursor-pointer block py-2"
                    >
                      <i className="ri-arrow-left-s-line ml-2"></i>
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Services Accordion */}
          <div>
            <button
              onClick={() => toggleAccordion('services')}
              className="w-full flex items-center justify-between text-white font-semibold text-lg py-3 cursor-pointer whitespace-nowrap"
            >
              خدماتنا
              <i className={`ri-arrow-down-s-line transition-transform ${openAccordion === 'services' ? 'rotate-180' : ''}`}></i>
            </button>
            {openAccordion === 'services' && (
              <ul className="mt-4 space-y-3">
                {services.map((service, index) => (
                  <li key={index}>
                    <Link 
                      to={service.path} 
                      className="text-gray-300 hover:text-[#E71B25] transition-colors text-sm cursor-pointer block py-2"
                    >
                      <i className="ri-arrow-left-s-line ml-2"></i>
                      {service.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-gray-600">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <p className="text-gray-400 text-sm">
              © 2025 شركة فيبا التجارية — جميع الحقوق محفوظة.
            </p>
            
            <div className="flex flex-col md:flex-row md:items-center gap-4">
              {/* Language Switch */}
              <a 
                data-lang="en"
                className="lang-btn-footer text-gray-300 hover:text-[#E71B25] transition-colors font-medium cursor-pointer"
                aria-label="Switch to English"
              >
                English
              </a>
              
              {/* Social Icons */}
              <div className="flex items-center gap-4">
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill group-hover:scale-110 transition-transform"></i>
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill group-hover:scale-110 transition-transform"></i>
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-fill group-hover:scale-110 transition-transform"></i>
                </a>
              </div>
              
              {/* Quality Badges */}
              <div className="flex items-center gap-3 md:border-r md:border-gray-600 md:pr-4">
                <div className="flex items-center gap-2 text-xs text-gray-400">
                  <i className="ri-medal-line text-[#E71B25]"></i>
                  <span>ISO 9001</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-400">
                  <i className="ri-shield-check-line text-[#E71B25]"></i>
                  <span>HSE Certified</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}